// Renders @mentions inside post/comment content as real profile links --
// but only for usernames the backend already validated (mentionedUsernames,
// from GroupPostDisplay/GroupCommentDisplay's own field), never every
// "@word"-shaped substring. A typo or a non-existent username stays plain
// text instead of becoming a dead link. See
// Technical_Docs/27_GROUP_POST_MENTIONS_DESIGN.md §5.
import React from 'react';
import { Link } from 'react-router-dom';

const MENTION_TOKEN_RE = /@([a-zA-Z0-9_]{8,32})/g;

export function renderContentWithMentions(content, mentionedUsernames) {
  if (!content) return content;
  if (!mentionedUsernames || mentionedUsernames.length === 0) return content;

  const validated = new Set(mentionedUsernames.map((u) => u.toLowerCase()));
  const parts = [];
  let lastIndex = 0;
  let match;
  let key = 0;

  MENTION_TOKEN_RE.lastIndex = 0;
  while ((match = MENTION_TOKEN_RE.exec(content)) !== null) {
    const [full, username] = match;
    if (!validated.has(username.toLowerCase())) continue;

    if (match.index > lastIndex) {
      parts.push(content.slice(lastIndex, match.index));
    }
    parts.push(
      <Link
        key={`mention-${key++}`}
        to={`/public-profiles/${encodeURIComponent(username)}`}
        className="text-violet-400 hover:text-violet-300 hover:underline font-medium"
      >
        @{username}
      </Link>
    );
    lastIndex = match.index + full.length;
  }

  if (lastIndex < content.length) {
    parts.push(content.slice(lastIndex));
  }

  return parts;
}
